// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"efb74b2a","227":"0fafa697","411":"59ccf760","451":"b1a64723","453":"61595904","477":"84378f9a","523":"64365e08","524":"63e3d05a","546":"37d06ac9","600":"c0e19438","640":"64847685","781":"3a99611f","873":"ba8a0be5","942":"5721700a"}[chunkId] + ".chunk.js";
};